{
  "accountantConfirmation": "Revisorbekreftelse",
  "accountantDelivered": "Levert",
  "admission": "Opptak",
  "active": "Aktiv",
  "added": "Lagt inn",
  "address": "Adresse",
  "advisor": "Rådgiver",
  "billNumber": "Faktura nr.",
  "budget": "Budsjett",
  "category": "Kategori",
  "city": "Poststed",
  "contactPerson": "Kontaktperson",
  "contactStatus": "Kontaktstatus",
  "contractStart": "Avtalestart",
  "county": "Fylke",
  "dateAdded": "Dato lagt til",
  "deactivatedDate": "Utmeldt",
  "deductible": "Egenandel",
  "delivered": "Levert",
  "description": "Beskrivelse",
  "dueDate": "Forfallsdato",
  "email": "E-post",
  "endDate": "Sluttdato",
  "ended": "Sluttet",
  "establishedDate": "Etableringsdato",
  "eventDate": "Eventdato",
  "eventName": "Eventnavn",
  "firstName": "Fornavn",
  "focusArea": "Fokusområde",
  "focusAreas": "Fokusområder",
  "gender": "Kjønn",
  "hourRate": "Timesats",
  "hours": "Timer",
  "id": "ID",
  "ideaName": "Idénavn",
  "inkind": "Egeninnsats",
  "inkindStatus": "Egeninnsatsstatus",
  "innovationSupport": "Innovasjonsstøtte",
  "innovation-support": "Innovasjons-støtte",
  "interestAreas": "Interesseområder",
  "international": "Internasjonal",
  "invitationStatus": "Invitasjonsstatus",
  "lastName": "Etternavn",
  "lastChangedDate": "Sist endret",
  "mainContact": "Hovedkontakt",
  "mainContactEmail": "Hovedkontakt epost",
  "mainGoal": "Hovedmål",
  "markAllRows": "Merk alle rader",
  "marketValue": "Markedsverdi",
  "markRow": "Merk rad {{index}}",
  "member": "Medlem",
  "memberCompany": "Medlemsbedrift",
  "memberSince": "Medlem siden",
  "municipalities": "Kommuner (Førstelinjetjeneste for)",
  "name": "Navn",
  "numberOfEmployees": "Antall ansatte",
  "numberOfParticipants": "Antall deltagere",
  "organizationNumber": "Organisasjonsnummer",
  "participants": "Deltagere",
  "phase": "Fase",
  "phone": "Telefon",
  "postalCode": "Postkode",
  "projectLeader": "Prosjektleder",
  "projectName": "Prosjektnavn",
  "resourceBaseContact": "Kontakt i ressursbasen",
  "responsible": "Ansvarlig",
  "retired": "Utmeldt",
  "retiredDate": "Utmeldt dato",
  "roles": "Roller",
  "selfEffort": "Egeninnsats",
  "selfEffortStatus": "Egeninnsats status",
  "deliveryTypes": "Leveransetyper",
  "source": "Kilde",
  "startDate": "Startdato",
  "status": "Status",
  "subProject": "Delprosjekt",
  "supportIntensity": "Støtteintensitet",
  "support-intensity": "Støtte-intensitet",
  "targetNumberName": "Måltallsnavn",
  "type": "Type",
  "company": "Bedrift",
  "visible": "Synlig",
  "move": "Flytt",
  "workGroup": "Arbeidsgruppe",
  "expandRow": "Vis mer",
  "collapseRow": "Vis mindre",
  "editTabelView": "Endre tabellvisning",
  "column": "Kolonne",
  "export": "Eksport",
  "organization": "Organisasjon",
  "accessType": "Tilgangstype",
  "title": "Tittel",
  "statusName": "Aktørtype",
  "submittedDate": "Innsendt dato",
  "municipality": "Kommune",
  "customerName": "Kundenavn",
  "actorName": "Aktørnavn",
  "actorProfile": "Aktørprofil",
  "comment": "Kommentar",
  "referredCorrectly": "Henvist rett",
  "rowCannotBeMarked": "Denne raden kan ikke bli valgt",
  "year": "År",
  "fileName": "Filnavn",
  "download": "Filnedlasting",
  "numericId": "ID",
  "companyName": "Bedrift",
  "fromDate": "Opptaksdato",
  "registrationDate": "Registreringsdato",
  "sivaEndDate": "Avtaleslutt",
  "preInkFunds": "Preinkubasjon",
  "otherFunds": "Øvrige faser",
  "totalFunds": "Total sum",
  "admissionDate": "Opptak",
  "portfolioIndustries": "Bransjer",
  "selfClassification": "Klassifisering",
  "organizationName": "Bedriftsnavn",
  "selfDeclaration": "Egenerklæring",
  "goalAccomplishment": "Måloppnåelse",
  "esa": "ESA",
  "serviceName": "Tjenestenavn",
  "actor": "Aktør",
  "statusProgramHint": "Inkubator/Næringshage",
  "spentArt28": "Brukt art. 28",
  "spentArt28PreInc": "Brukt art. 28 (preink.)",
  "reportingCompleted": "Rapportering ferdig",
  "reportingYearOpen": "Rapportår åpent",
  "publishingDate": "Publiseringsdato",
  "validTo": "Gyldig til",
  "deliveredServices": "Leverte tjenester",
  "contactEmail": "Kontaktperson e-post",
  "industry": "Bransje",
  "invoiceDate": "Fakturadato",
  "clusterMemberName": "Navn",
  "clusterMemberOrgNo": "Org nr.",
  "services": "Tjenester",
  "registeredRecommended": "Registrert anbefalt",
  "dateRecommended": "Dato anbefalt",
  "registeredDelivered": "Registrert levert",
  "dateDelivered": "Dato levert",
  "recommendedStatus": "Anbefalt status",
  "deliveredStatus": "Levert status",
  "sendRecommendation": "Send anbefaling",
  "markAsRecommended": "Marker som anbefalt",
  "markAsDelivered": "Marker som levert"
}
